// A full width band with the house vertical rhythm and one of three grounds.
//
// Monzo’s page is a stack of these: canvas, surface, canvas, navy. The ground
// alternates so sections separate themselves without rules or borders.
//
//   canvas   #F2F8F3, the page ground
//   surface  #FFFFFF, a lifted band
//   navy     #091723, the full bleed dark moment. White text, and any button
//            inside it must be variant="light".
//
// `width` is the inner measure: 'wide' for section grids, 'text' for prose that
// has to stay readable (65 characters or so).

const GROUNDS = {
  canvas:  'bg-canvas text-ink',
  surface: 'bg-surface text-ink',
  navy:    'bg-navy text-white',
}

const WIDTHS = {
  wide: 'max-w-[1200px]',
  text: 'max-w-[720px]',
}

export default function Section({
  ground = 'canvas', width = 'wide', id, className = '', innerClassName = '', children,
}) {
  return (
    <section id={id} className={`${GROUNDS[ground]} px-6 py-16 md:py-24 ${className}`}>
      <div className={`${WIDTHS[width]} mx-auto ${innerClassName}`}>{children}</div>
    </section>
  )
}
